/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Weekdays_RequiredInputs */

const vi_irrigation_schedule_weekdays_required = /** @type {(inputs: Irrigation_Schedule_Weekdays_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất một ngày áp dụng`)
};

/**

* @param {Irrigation_Schedule_Weekdays_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_weekdays_required = /** @type {((inputs?: Irrigation_Schedule_Weekdays_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Weekdays_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_weekdays_required(inputs)
});